const {
    connectedRouterRedirect
} = require("redux-auth-wrapper/history4/redirect");
const AuthStatuses = require("strange-auth").statuses;
const Replace = require("react-router-redux").replace;

exports.authenticate = connectedRouterRedirect({
    authSelector: state => state.auth,
    authenticatedSelector: state => state.auth.isAuthenticated,
    authenticatingSelector: state => {
        return (
            state.auth.status === AuthStatuses.INIT ||
            state.auth.status === AuthStatuses.WAITING
        );
    },
    redirectPath: "/login",
    redirectAction: Replace,
    failureRedirectPath: "/",
    allowRedirectBack: false
});

exports.authenticateAdmin = connectedRouterRedirect({
    authSelector: state => state.auth,
    authenticatedSelector: state =>
        state.auth.isAuthenticated && state.auth.credentials.user.isAdmin,
    authenticatingSelector: state => {
        return (
            state.auth.status === AuthStatuses.INIT ||
            state.auth.status === AuthStatuses.WAITING
        );
    },
    redirectPath: "/login",
    redirectAction: Replace,
    failureRedirectPath: "/",
    allowRedirectBack: false
});



// WEBPACK FOOTER //
// ./src/routes/utils.js